export default "__VITE_ASSET__DpxEJr9___"